const SHARE_OPTIONS = {
  tw: {
    name: "Twitter",
    getUrl: ({ link, title }) => `https://twitter.com/intent/tweet?url=${link}&text=${title}`
  },
  fb: {
    name: "Facebook",
    getUrl: ({ link, title }) => `http://www.facebook.com/sharer.php?u=${link}&via=tint&t=${title}`
  },
  li: {
    name: "LinkedIn",
    getUrl: ({ link, title }) => `https://www.linkedin.com/shareArticle?url=${link}&title=${title}&source=TINT`
  },
  pin: {
    name: "Pinterest",
    getUrl: ({ link, title, body }) => `https://www.pinterest.com/pin/create/button/?url=${link}&description=${title}&media=${body}`
  },
  email: {
    name: "Email",
    getUrl: ({ title }) => `mailto:?subject=You+are+going+to+love+this&body=${title}`
  }
};
export default SHARE_OPTIONS;
